import {useTranslation} from 'react-i18next';
import {useGuestFormEnv} from '../env';
import {isPdfUrl} from '../helpers';
import {useFetchPrivacyPolicySettings} from './useFetchPrivacyPolicySettings';

type ResolvePrivacyPolicyLinkArgs = {
  privacyPolicyUrl?: string;
  hasCustomPrivacyPolicy: boolean;
  documentDownload: string;
  isLoading: boolean;
  defaultHref: string;
};

function resolvePrivacyPolicyLink({
  privacyPolicyUrl,
  hasCustomPrivacyPolicy,
  documentDownload,
  isLoading,
  defaultHref,
}: ResolvePrivacyPolicyLinkArgs) {
  if (privacyPolicyUrl) {
    return {
      href: privacyPolicyUrl,
      isCustomDocument: false,
      isPdf: isPdfUrl(privacyPolicyUrl),
      isLoading: false,
    };
  }

  const isCustomDocument = hasCustomPrivacyPolicy && Boolean(documentDownload);
  const href = isCustomDocument ? documentDownload : defaultHref;

  return {href, isCustomDocument, isPdf: isCustomDocument || isPdfUrl(href), isLoading};
}

function usePrivacyPolicyLink() {
  const {t} = useTranslation();
  const {housingId, privacyPolicyUrl} = useGuestFormEnv();
  const {hasCustomPrivacyPolicy, documentDownload, isLoading} =
    useFetchPrivacyPolicySettings({housingId});

  return resolvePrivacyPolicyLink({
    privacyPolicyUrl,
    hasCustomPrivacyPolicy,
    documentDownload,
    isLoading,
    defaultHref: t('guest_privacy_policy_link'),
  });
}

export {resolvePrivacyPolicyLink, usePrivacyPolicyLink};
